let io = require('socket.io-client');
// import isOffline from '../isOffline';
import isDevelopment from '../isDevelopment';


export default async function createSocket() {
	let transporterCode = localStorage.getItem('transporterCode');
	let { hostname } = location;
	let url = `https://notifications.${hostname}/${transporterCode}`;
	if (isDevelopment()) {
		url = `http://${hostname}:4999/${transporterCode}`;
	}
	//	let token = await getUserToken();


	let socket = io(url, {
		query: {
			transporterCode
		},
		reconnectionAttempts: 3
		//		transportOptions: {
		//			polling: {
		//			  extraHeaders: { Authorization: `Bearer ${token}` }
		//			}
		//		}
	});

	socket.on('connect', () => {
		console.log('connected');
	});
	socket.on('connect_error', (error) => {
		console.log(error);
	});
	socket.on('connect_timeout', (error) => {
		console.log(error);
	});
	socket.on('error', (error) => {
		console.log(error);
	});

	return socket;
}

// async function getUserToken() {
// 	if (isOffline()) return 'fakeToken';

// 	try {
// 		let userAuth = require('../userAuth').default;
// 		let user = await userAuth.getCurrentUser();

// 		if (!user) throw new Error('User not logged in');

// 		let userToken = await user.getIdToken();
// 		return userToken;
// 	} catch (err) {
// 		return new Error(err.message);
// 	}
// }
